/**
 * @fileoverview Modal component.
 * This component displays a modal with a backdrop and a content area.
 */

import { ModalConfig } from './Context'
import * as css from './Modal.module.css'

/**
 * @function Modal
 * @description The modal component.
 * @param {ModalConfig} props - The props for the modal.
 * @returns {JSX.Element} - A React component that renders the modal.
 */
export function Modal(props: ModalConfig) {
    return (
        <div className={css.backdrop}>
            <div className={css.modal}>{props.content}</div>
        </div>
    )
}
